import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import axios from "../axios";

import "../../CSS/Sidedrawer.css";
// import { Button } from "react-bootstrap";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import CloseIcon from "@mui/icons-material/Close";
// import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import UserListItem from "./UserListItem";

// import Modal from '@mui/material/Modal';
// import Backdrop from '@mui/material/Backdrop';
// import Modal from "react-bootstrap/Modal";
import Drawer from "@mui/material/Drawer";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer } from "react-toastify";
// import { IconButton } from "@mui/material";
// import { Menu, MenuItem, MenuButton } from "@szhsin/react-menu";
// import Dropdown from "react-bootstrap/Dropdown";
// import { styled } from "@mui/system";
import Avatar from "@mui/material/Avatar";
import ProfileModal from "../miscellaneous/ProfileModal";
import LogoutModal from "../miscellaneous/LogoutModal";
import DevModal from "../miscellaneous/DevModal";
import ContentLoading from "../miscellaneous/ContentLoading";
import { getSenderName } from "../config/ChatLogics";
// import NotificationBadge, { Effect } from "react-notification-badge";
import NotificationBadge from "react-notification-badge";
import { Effect } from "react-notification-badge";

const Sidedrawer = (props) => {
  // console.log("props", props);
  const [search, setSearch] = useState();
  const [chats, setChats] = useState(props.chats);
  const [searchResult, setSearchResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingChat, setLoadingChat] = useState();
  const [selectedChat, setSelectedChat] = useState();
  const [userInfo, setUserInfo] = useState(props.userInfo);
  const [notificationMenu, setNotificationMenu] = useState(null);
  const [profileMenu, setProfileMenu] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const [drawerState, setDrawerState] = useState(false);
  const [devModal, setDevModal] = useState(false);
  // const navigate = useNavigate();
  const [notification, setNotification] = useState("");
  const [windowInnerwidth, setWindowInnerWidth] = useState(0);
  useEffect(() => {
    function handleResize() {
      // console.log("window.innerWidth",window.innerWidth);
      setWindowInnerWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setWindowInnerWidth]);

  useEffect(() => {
    if (
      props.notification &&
      props.notification !== undefined &&
      props.notification !== [] &&
      props.notification !== ""
    ) {
      // console.log("props.notification2", props.notification);
      setNotification(props.notification);
    }
  }, [props]);
  // console.log("notification2", notification);

  //------------Open Notification Menu------------
  const openNotification = Boolean(notificationMenu);
  const notificationClick = (event) => {
    // console.log("event.currentTarget", event.currentTarget);
    setNotificationMenu(event.currentTarget);
  };
  const notificationClose = () => {
    setNotificationMenu(null);
  };
  //------------Open Profile Menu------------
  const openProfile = Boolean(profileMenu);
  const profileClick = (event) => {
    setProfileMenu(event.currentTarget);
  };
  const profileClose = () => {
    setProfileMenu(null);
    // profileModalShow();
    setProfileModal(true);
  };

  //------------Logout Function------------

  const logout = () => {
    setProfileMenu(null);
    setLogoutModal(true);
    // localStorage.removeItem("userInfo");
    // navigate("/", { replace: true });
  };
  //------------Open Profile Modal------------

  // const profileModalClose = () => setProfileModal(false);
  // const profileModalShow = () => setProfileModal(true);

  //------------Search Function------------
  const SearchUsers = async (token) => {
    // console.log("token", token);
    if (!search) {
      // toast.error("Please enter something in search bar", {
      //   position: "top-left",
      //   toastId: 17,
      // });
      return;
    }
    try {
      setLoading(true);
      const token = userInfo.token;
      await axios
        .get(`/user?search=${search}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setSearchResult(res.data);
          // if (res.data.length < 1) {
          //   toast.error("No User found", {
          //     position: "top-left",
          //     toastId: 15,
          //   });
          // }
        });
      setLoading(false);
      // setSearch("");
    } catch (error) {
      // toast.error("Error Occured", {
      //   toastId: 16
      // });
      console.log("Error Occured", error);
    }
  };
  //------------Access Chat-------------
  const accessChat = async (userId) => {
    // console.log("userid", userId);
    try {
      setLoadingChat(true);
      const token = userInfo.token;
      await axios
        .post(
          "/chat/",
          { userId },
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (!chats.find((c) => c._id === res.data._id)) {
            setChats([res.data, ...chats]);
          }
          // console.log('rssss',res.data)
          setSelectedChat(res.data);
          props.selectedChatHandler(res.data);
        });
      setLoadingChat(false);
      setDrawerState(false);
    } catch (error) {
      console.log("Error Occured white trying to access chat", error);
    }
    // await props.selectedChatHandler(selectedChat);
  };
  const funcc = () => {
    // console.log("HELLO");
    setDevModal(true);
  };
  // const getChats = (chatsComing) =>{
  //   console.log('coooo',chatsComing)
  // }
  return (
    <>
      <div className="sidedrawer" style={{ width: "100%" }}>
        {windowInnerwidth > 768 ? (
          <>
            <Tooltip title={<h6>"Search User to chat"</h6>} placement="bottom">
              <div className="search_button_container">
                <div className="sidedrawer_searchButton">
                  {/* <input type="text" placeholder="Search User" /> */}
                  {/* <Button variant="ghost" className="searchButton" onClick={() => setDrawerState(true)}>
                <SearchOutlinedIcon />
                <span className="searchPlaceholder">Search User or New Chat</span>
              </Button> */}
                  <div
                    className="searchButton"
                    onClick={() => setDrawerState(true)}
                  >
                    <SearchOutlinedIcon />
                    <span className="searchPlaceholder">
                      Search User or New Chat
                    </span>
                  </div>
                </div>
              </div>
            </Tooltip>
          </>
        ) : (
          <></>
        )}
        {/* <div className="chatAppName" onClick={() => setDevModal(true)}> */}
        <div className="chatAppName" onClick={funcc}>
          {/* <p>Talk'n Talk</p> */}
          GupShup
          <div>
            <p>by</p>
            <p>
              <span>Nadeem</span> <span>Mansha</span>
            </p>
          </div>
          {/* <div>Nadeem Mansha</div> */}
        </div>
        <div className="navbar_buttons">
          <Button
            id="notification-button"
            aria-controls={openNotification ? "notification-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openNotification ? "true" : undefined}
            onClick={notificationClick}
            className="notificationBtn"
          >
            <NotificationsActiveOutlinedIcon />
            <NotificationBadge
              count={notification.length}
              effect={Effect.SCALE}
            />
          </Button>
          <Menu
            id="notification-menu"
            anchorEl={notificationMenu}
            open={openNotification}
            onClose={notificationClose}
            MenuListProps={{
              "aria-labelledby": "notification-button",
            }}
          >
            <MenuItem onClick={notificationClose}>
              {/* {notification.length} */}
              {!notification.length && "No New Message"}
            </MenuItem>

            {notification &&
              notification.map((notifi) => (
                <MenuItem
                  key={notifi._id}
                  onClick={() => {
                    props.openChatHandler(notifi.chat[0]);
                    setNotification(notification.filter((n) => n !== notifi));
                    props.setNotification(
                      notification.filter((n) => n !== notifi)
                    );
                    notificationClose();
                  }}
                >
                  {notifi.chat[0].isGroupChat
                    ? `New Message in ${notifi.chat[0].chatName}`
                    : `
                  New Message from ${getSenderName(
                    userInfo,
                    notifi.chat[0].users
                  )}
                  `}
                </MenuItem>
              ))}
          </Menu>
          <Button
            id="profile-button"
            aria-controls={openProfile ? "profile-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openProfile ? "true" : undefined}
            onClick={profileClick}
          >
            <Avatar src={userInfo.pic} name={userInfo.name} />
          </Button>
          <Menu
            id="profile-menu"
            anchorEl={profileMenu}
            open={openProfile}
            onClose={() => setProfileMenu(null)}
            MenuListProps={{
              "aria-labelledby": "profile-button",
            }}
          >
            <MenuItem onClick={profileClose}>Profile</MenuItem>
            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>

          {profileModal ? (
            <ProfileModal
              userInfo={userInfo}
              profileModal={profileModal}
              setProfileModal={setProfileModal}
            />
          ) : null}
          {logoutModal ? (
            <LogoutModal
              userInfo={userInfo}
              logoutModal={logoutModal}
              setLogoutModal={setLogoutModal}
            />
          ) : null}
          {devModal ? (
            <DevModal devModal={devModal} setDevModal={setDevModal} />
          ) : null}
        </div>
        <Drawer
          anchor={"left"}
          open={drawerState}
          onClose={() => setDrawerState(false)}
        >
          {/* <h3>Search User</h3> */}
          <div className="sidedrawer_search">
            <div className="sidedrawer_searchContainer">
              <input
                type="text"
                value={search}
                placeholder=" Search by name or email "
                // onChange={(e) => setSearch(e.target.value)}
                onChange={(e) => {
                  setSearch(e.target.value);
                  SearchUsers();
                }}
              />
              {/* <Button variant="ghost" onClick={SearchUsers}>
                <b>Go</b>
              </Button> */}
              <div
                className="drawerCloseButton"
                onClick={() => setDrawerState(false)}
              >
                <CloseIcon></CloseIcon>
              </div>
            </div>
          </div>
          <div className="search_result">
            {/* {searchResult &&
              searchResult.map((user) => {
                <div>asasdsad</div>
              })} */}
            {loading ? (
              <div style={{ width: "100%" }}>
                <ContentLoading loadingFor={"sidedrawer"} />
              </div>
            ) : (
              searchResult.map((user) => {
                return (
                  <>
                    <UserListItem
                      key={user._id}
                      user={user}
                      userHandler={() => accessChat(user._id)}
                    />
                    {loadingChat ? (
                      <div className="spinner_container">
                        <Spinner animation="border" variant="secondary" />
                      </div>
                    ) : null}
                  </>
                );
              })
            )}
          </div>
          {/* {selectedChat ? null : null} */}
          {/* <UserListItem searchResult={searchResult}/> */}
        </Drawer>
      </div>
      <div>
        {windowInnerwidth < 768 ? (
          <>
            <Tooltip title={<h6>"Search User to chat"</h6>} placement="bottom">
              <div className="search_button_container">
                <div className="sidedrawer_searchButton">
                  {/* <input type="text" placeholder="Search User" /> */}
                  {/* <Button variant="ghost" className="searchButton" onClick={() => setDrawerState(true)}>
                <SearchOutlinedIcon />
                <span className="searchPlaceholder">Search User or New Chat</span>
              </Button> */}
                  <div
                    className="searchButton"
                    onClick={() => setDrawerState(true)}
                  >
                    <SearchOutlinedIcon />
                    <span className="searchPlaceholder">
                      Search User or New Chat
                    </span>
                  </div>
                </div>
              </div>
            </Tooltip>
          </>
        ) : (
          <></>
        )}
      </div>
      {/* Mobile View */}
      <ToastContainer
        // position="bottom-center"
        position={windowInnerwidth > 500 ? "bottom-center" : "top-center"}
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
    </>
  );
};

export default Sidedrawer;
